import { Component, Vue } from "vue-property-decorator";

import TagsModal from "@/components/tagsModal/tagsModal";
import { Getter } from "vuex-class";

import AvoidTagsFilter from "@/components/avoidTagsFilter/avoidTagsFilter";

@Component({
  components: {
    TagsModal,
    AvoidTagsFilter,
  },
})
export default class EditSubscriptionTags extends Vue {
  @Getter getSubscription;

  isShowingTagsModal = false;

  get getAvoidProteinTags() {
    return this.getSubscription.tags.filter((tag) => tag.type_tag === "aggregate");
  }

  get getAvoidProductsTags() {
    return this.getSubscription.tags.filter((tag) => tag.type_tag === "avoid");
  }
}
